import React from 'react';
import { Link } from 'react-router-dom';
import { useFilterContext } from '../../context/filterContext';
import logo from '../assets/logo-mobile.png'
import { useAlertContext } from '../../context/alertContext';


export default function Navbar(props) {

    const { filters: { text }, updateFilterValue } = useFilterContext();
    const { showAlert } = useAlertContext()


    const Logout = () => {
        props.handleLogout()
        showAlert('Profile has been Logout!', 'success', '#check-circle-fill' )
    }

    return (
        <section>
            <nav class="navbar navbar-dark bg-primary position-sticky top-0 d-none d-md-block">
                <div className="container">
                    <Link className="navbar-brand "> <img className='img-fluid nav-logo bg-black' src={logo} alt="logo" /></Link>
                    <form className="d-flex col-3 ms-auto me-4" role="search" onSubmit={(e) => { e.preventDefault() }}>
                        <input
                            className="form-control me-2 "
                            type="text"
                            placeholder='Search'
                            aria-label="Search"
                            onChange={updateFilterValue}
                            value={text}
                            name='text'
                        />
                    </form>
                    <button className='logoutBtn' onClick={Logout}>Logout</button>
                </div>
            </nav>

            <nav className="navbar  bg-primary navbar-dark fixed-top d-md-none">
                <div className="container-fluid">
                    <Link className="navbar-brand "> <img className='img-fluid nav-logo bg-black' src={logo} alt="logo" /></Link>

                    <button
                        className="navbar-toggler"
                        type="button"
                        data-bs-toggle="offcanvas"
                        data-bs-target="#offcanvasNavbar"
                        aria-controls="offcanvasNavbar"
                    >
                        <span className="navbar-toggler-icon" />
                    </button>
                    <div
                        className="offcanvas offcanvas-end w-75"
                        tabIndex={-1}
                        id="offcanvasNavbar"
                        aria-labelledby="offcanvasNavbarLabel"
                    >
                        <div className="offcanvas-header">
                            <h5 className="offcanvas-title" id="offcanvasNavbarLabel">
                                Welcome to TBC Experts
                            </h5>
                            <button
                                type="button"
                                className="btn-close"
                                data-bs-dismiss="offcanvas"
                                aria-label="Close"
                            />
                        </div>
                        <div className="offcanvas-body">

                            <form className="d-flex" role="search" onSubmit={(e) => { e.preventDefault() }}>
                                <input
                                    className="form-control me-2 "
                                    type="text"
                                    placeholder="Search"
                                    aria-label="Search"
                                    onChange={updateFilterValue}
                                    value={text}
                                    name='text'
                                />
                            </form>
                            <button className='logoutBtn mt-3' onClick={Logout}>Logout</button>
                        </div>
                    </div>
                </div>
            </nav>
        </section>
    );
}
